import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { uploadWidgetFilenameField } from '../createUploadWidgetFormSchema';

/**
 * Hook per gestire la lista dei file di un widget di upload
 */
export function useUploadWidgetFileList(name: string) {
  const filenameFieldName = uploadWidgetFilenameField(name);

  const id = useWatch({ name }) as string;
  const filename = useWatch({ name: filenameFieldName }) as string;

  const [fileList, setFileList] = useState(() => {
    return id && filename
      ? [
          {
            uid: id,
            name: filename,
            status: 'done' as const,
          },
        ]
      : [];
  });

  useEffect(() => {
    if (filename && id) {
      setFileList([
        {
          uid: id,
          name: filename,
          status: 'done' as const,
        },
      ]);
    } else {
      setFileList([]);
    }
  }, [filename, id]);

  return { fileList, setFileList };
}
